<ng-container *ngIf="cs.vm$ | async as vm">
  <form
    *ngIf="cs.form as form"
    (submitted)="onSubmit($event)"
    [dgxTestHook]="testHooks.Form"
    [formGroup]="cs.form"
    class="mb-6"
    dgxFormSubmit
    dgxGaFormSubmit
  >
    <dgx-form-row>
      <dgx-form-field
        [dgxTestHook]="testHooks.PaymentTypeRadio"
        [label]="'PAYMENT_METHOD_LABEL' | translate"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="paymentType"
      >
        <dgx-form-radio-card [option]="cs.paymentMethodOptions.directDebit">
          <ng-template #radioCardHeaderTemplate>
            <h5>{{ cs.paymentMethodOptions.directDebit.label }}</h5>
          </ng-template>
          <p class="mb-2">
            {{
              'PAYMENT_METHOD_MONTHLY_LABEL'
                | translate
                  : {
                      value:
                        vm.selectedQuotesTotalDirectDebitPayment
                        | currencyFormat
                    }
            }}
          </p>
          <p class="mb-2">
            <strong>
              {{
                'PAYMENT_METHOD_TOTAL_COST'
                  | translate
                    : {
                        value: vm.selectedQuotesTotalPayment | currencyFormat
                      }
              }}
            </strong>
          </p>
          <p class="mb-2 payment-method__discount_text">
            <b>{{
              'PAYMENT_METHOD_DIRECT_DEBIT__HIGHLIGHTED_TEXT'
                | translate : { discount: 10 | currencyFormat }
            }}</b>
          </p>
          <svg
            xml:space="preserve"
            class="direct-debit-form__action-icon"
            id="Layer_1"
            version="1.1"
            viewBox="0 0 2279.4 737.7"
            width="80px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="M1072.3,154.9h118.2c0,0,117.1-2.4,115.9,104c-1.2,79.2-113.5,91-113.5,91h-120.6L1072.3,154.9L1072.3,154.9   L1072.3,154.9z M1426,536.8c3.3,15.5,14.5,32.5,51.9,34.3c49.6,1.2,78-17.8,78-17.8V590c0,0-54.4,13-80.4,13   c-27.2,0-107.6-5.9-107.6-80.4c0-60.3,66.2-79.2,104-79.2c66.2,2.4,98.1,26,96.9,93.4C1568.9,537.7,1459.9,537,1426,536.8   L1426,536.8z M1426.1,507.2h90.7c0,0,0-34.3-43.7-34.3C1440.2,472.9,1429.4,490.7,1426.1,507.2z M1713.1,470.2   c13.1-14.2,35.2-25.6,72.1-25.6c73.3,0,85.1,61.5,84,78c-1.2,16.5-7.1,79.2-92.2,79.2c-32.2,0-51.8-11-63.9-24.6V597h-57.9V384.2   h57.9L1713.1,470.2L1713.1,470.2L1713.1,470.2z M1762.8,568.7c34.3-1.2,49.6-30.7,49.6-44.9s-8.3-43.7-52-43.7   c-33.9,0-44.3,25.6-47.3,38.2v15.4C1716.1,546.4,1726.5,568.7,1762.8,568.7L1762.8,568.7z M2262.9,562.8l1.2,33.1   c0,0-27.2,5.9-44.9,5.9s-63.9-10.6-63.9-55.6v-68.6h-48.5v-30.7h48.5v-36.7h59.1v36.7h48.5v30.7h-48.5v59.1c0,0,0,29.6,23.7,29.6   C2261.7,566.3,2262.9,562.8,2262.9,562.8L2262.9,562.8z M2083.2,186.8h68.6v164.3h57.9V186.8h69.8v-34.3h-196.2V186.8z    M2059.5,195.1l7.1-34.3c0,0-29.6-13-81.6-13c-50.8,0-132.4,28.4-132.4,105.2c0,75.7,86.3,101.7,139.5,101.7   c53.2,0,70.9-8.3,70.9-8.3l-5.9-37.8c0,0-23.7,7.1-63.9,7.1c-39-1.2-79.2-31.9-79.2-66.2c1.2-30.7,36.6-65,82.8-65   C2032.3,184.4,2059.5,195.1,2059.5,195.1L2059.5,195.1z M1536.9,153.7c0,0,96.9-4.7,96.9,52c0,48.5-55.5,52-55.5,52   s15.4,2.4,22.5,13c5.9,9.5,44.9,80.4,44.9,80.4h-59.1c0,0-9.5-11.8-14.2-20.1c-3.5-8.3-14.2-26-14.2-26s-8.3-29.6-36.7-29.6   c-0.7,0-12.3-0.4-21.3-0.8v76.4h-56.7V153.7L1536.9,153.7L1536.9,153.7z M1500.3,242.4h30.8c0,0,42.6-2.4,44.9-28.4   c1.2-24.8-41.4-28.4-41.4-28.4h-34.3L1500.3,242.4L1500.3,242.4z M1737.9,273.1h94.6v-36.7h-94.6v-44.9h102.9v-37.8H1680v197.4h162   v-35.5h-104.1L1737.9,273.1L1737.9,273.1L1737.9,273.1z M1968.5,424.4h57.9v-40.2h-57.9V424.4z M1968.5,597.1h57.9V446.9h-57.9   V597.1z M1337.2,351.1h56.7V153.7h-56.7V351.1L1337.2,351.1z M1072.3,400.8h118.2c0,0,117.1-2.4,115.9,104   c-1.2,79.2-113.5,91-113.5,91h-120.6L1072.3,400.8L1072.3,400.8L1072.3,400.8z M1130.3,559.2h37.8c0,0,78-4.7,78-65   s-82.8-66.2-82.8-66.2h-33.1V559.2z M1130.3,313.3h37.8c0,0,78-5.9,78-65c0-61.5-82.8-66.2-82.8-66.2h-33.1V313.3z M541.5,272.4   V668c0,0-229.4-41.4-229.4-198.6C312.1,344,481.9,288.7,541.5,272.4z M541.5,265C403.6,255.1,91,319.7,91,461.1   c0,92.2,165.5,227,435.1,230.5c10.6,0,316.8-11.8,312.1-340.5c-4-276-210.6-324.4-276.6-332.8V1.5   c263.4,16.7,470.5,175.1,470.5,367.4c0,203.4-231.7,368.9-516.7,368.9S0,572.2,0,368.9S230.5,0,515.5,0c8.7,0,17.4,0.2,26,0.5   L541.5,265L541.5,265L541.5,265z"
              />
            </g>
          </svg>
        </dgx-form-radio-card>
        <dgx-form-radio-card [option]="cs.paymentMethodOptions.card">
          <ng-template #radioCardHeaderTemplate>
            <h5>{{ cs.paymentMethodOptions.card.label }}</h5>
          </ng-template>
          <p class="mb-2">
            {{
              'PAYMENT_METHOD_ONE_OFF_LABEL'
                | translate
                  : {
                      value:
                        (vm.selectedQuotesTotalCardPayment | quoteOfferPrice)
                    }
            }}
          </p>
          <p class="mb-2">
            <strong>
              {{
                'PAYMENT_METHOD_TOTAL_COST'
                  | translate
                    : {
                        value: vm.selectedQuotesTotalPayment | currencyFormat
                      }
              }}
            </strong>
          </p>

          <checkout-card-payment-providers />
        </dgx-form-radio-card>
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-submit-button class="mt-6" variant="primary"
      >{{ 'PAYMENT_METHOD_FORM_SUBMIT_BUTTON' | translate }}
    </dgx-form-submit-button>
  </form>
</ng-container>
